


















































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import TelaGenerica from '@/components/layout/TelaGenerica.vue'
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue'
import SeletorDeAtributo from '@/components/produto/SeletorDeAtributo.vue'
import DialogoDeEdicaoDeAtributo from '@/components/produto/DialogoDeEdicaoDeAtributo.vue'
import { FindAtributoUseCase } from '@/usecases/produto/FindAtributoUseCase'
import { Atributo, Page } from '@/models'
import { CancelToken } from 'axios'
import { Pageable } from '@/models/Pageable'

@Component({
	components: {
		TelaGenerica,
		DialogoDeEdicaoDeAtributo,
		DataTableDeCrudPaginado,
		SeletorDeAtributo,
	},
})

export default class TelaDeAtributos extends Vue {
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeEdicao!: DialogoDeEdicaoDeAtributo
	
	findAtributoUseCase = new FindAtributoUseCase()
	atributos: Atributo[] = []
	busca = ''
	carregando = false
	editando = false
	
	headers = [
		{ text: 'Atributo', value: 'nome' },
	]

	abrirDialogoDeEditarMarca(indice: number) {
		this.editando = true
		const atributo = this.atributos[indice]
		this.dialogoDeEdicao.mostrar(atributo)
	}

	abrirDialogoDeCriarMarca() {
		this.editando = false
		const atributo = {id:"",nome:""}
		this.dialogoDeEdicao.mostrar(atributo)
	}

	async buscarPagina(paginavel: Pageable, parametros: {
		busca?: string
	}, cancelToken: CancelToken): Promise<Page<Atributo>> {
		const pagina = await this.findAtributoUseCase.find({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.atributos = pagina.content
		return pagina
	}

	@Watch('busca')
	novaBusca() {
		this.dataTablePaginado.reiniciar({
			busca: this.busca,
		})
	}
}
